import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, Target, Users, TrendingUp } from "lucide-react";
const NewSteps = () => {
  const features = [
    {
      icon: Target,
      title: "Step 1: Connect",
      description:
        "Schedule a Discovery Call to share your goals, challenges, and vision. This is where we listen, learn, and begin designing your path forward.",
    },
    {
      icon: Users,
      title: "Step 2: Customize",
      description:
        "Together, we'll build a tailored plan using the right mix of coaching, workshops, DISC assessments, and organizational agreements. Every program is designed to align personal growth with professional success.",
    },
    {
      icon: TrendingUp,
      title: "Step 3: Grow",
      description:
        "With your customized plan in place, we'll walk alongside you through coaching, mentorship, and experiential learning. You'll see measurable results in confidence, communication, collaboration, and leadership impact.",
    },
  ];
  return (
    <section className="py-20 bg-background">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-[#3372ec]">Your Growth Journey Starts Here</h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            We make it simple to begin. Whether you are an individual contributor, a team leader, or an organization
            ready for transformation, here's how we'll partner together to help you shine.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card key={index} className="border-border hover:border-primary transition-colors">
                <CardContent className="pt-6">
                  <div className="rounded-full w-12 h-12 flex items-center justify-center mb-4 bg-[#fdb12d]">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2 text-[#3372ec]">{feature.title}</h3>
                  <p className="text-muted-foreground">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="bg-muted/30 rounded-lg p-8 md:p-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8">
              <p className="text-hero-text mb-2 text-4xl font-bold px-[10px]">It's time to glow up your leadership.</p>
              <p className="text-hero-text mb-6 text-4xl font-bold px-[10px]">
                Let's create strategies that deliver next-level results in life and business.
              </p>
            </div>
            <div className="w-full" style={{ minHeight: "833px" }}>
              <iframe
                src="https://link.glowuplead.com/widget/form/tBEjb6E8InhoN4vjUBDs"
                style={{ width: "100%", height: "833px", border: "none", borderRadius: "8px" }}
                id="inline-tBEjb6E8InhoN4vjUBDs"
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Business Coaching"
                data-height="833"
                data-layout-iframe-id="inline-tBEjb6E8InhoN4vjUBDs"
                data-form-id="tBEjb6E8InhoN4vjUBDs"
                title="Business Coaching"
              />
            </div>
            <div className="text-center mt-8">
              <Button
                size="lg"
                className="gap-2"
                onClick={() =>
                  window.open("https://link.glowuplead.com/widget/service-menus/glowupleadprograms", "_blank")
                }
              >
                Book a Discovery Call
                <ArrowRight className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>
        <script src="https://link.glowuplead.com/js/form_embed.js" />
      </div>
    </section>
  );
};
export default NewSteps;
